module.exports = new __parcel__URL__("top-vendor-badge.d27cc922.svg").toString();